import { type ReactNode, useCallback } from 'react';

export const useCombineOptions = () =>
  useCallback(
    <ValueType extends { label: ReactNode; value: string }, OptionType extends ValueType = ValueType>(
      value: ValueType | ValueType[],
      option?: OptionType | OptionType[],
      formValue?: null | ValueType | ValueType[],
    ) => {
      const ensureArray = <T>(item: T | T[]) => (Array.isArray(item) ? item : [item]);

      const selectValues = ensureArray<ValueType>(value);
      const selectOptions = option ? ensureArray<OptionType>(option) : [];
      const formValues = formValue ? ensureArray<ValueType>(formValue) : [];

      const selectOptionsMap = new Map<string, OptionType>();
      const formValuesMap = new Map<string, ValueType>();

      for (const item of selectOptions) {
        if (Object.keys(item).length > 0) {
          selectOptionsMap.set(item.value, item);
        }
      }

      for (const item of formValues) {
        if (Object.keys(item).length > 0) {
          formValuesMap.set(item.value, item);
        }
      }

      return selectValues.map((item) => selectOptionsMap.get(item.value) ?? formValuesMap.get(item.value) ?? item);
    },
    [],
  );
